import { render, staticRenderFns } from "./TestWriting.vue?vue&type=template&id=0bbecdbc&scoped=true"
import script from "./TestWriting.vue?vue&type=script&lang=js"
export * from "./TestWriting.vue?vue&type=script&lang=js"
import style0 from "./TestWriting.vue?vue&type=style&index=0&id=0bbecdbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbecdbc",
  null
  
)

export default component.exports